<div class="password-indicator-box">
	<strong>Password should contain:</strong>
	<div *ngFor="let validator of passwordValidators" class="flex-container align-center m-t-10">

		<span class="ellipse">
			<svg width="27" height="27" viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg">
				<g clip-path="url(#clip0_3943_57719)">
					<ellipse *ngIf="validator.passed" cx="13.5482" cy="13.5473" rx="12.6566" ry="12.6566" fill="#0361F0"
						stroke="#0357EE" stroke-opacity="0.2" stroke-width="1.78313" />
					<ellipse cx="13.548" cy="13.5494" rx="7.30723" ry="7.30723" fill="#0361F0" />
					<circle *ngIf="!validator.passed" cx="13.5482" cy="13.5473" r="12.6566" fill="white"
						stroke="#0357EE" stroke-opacity="0.2" stroke-width="1.78313" />
					<path fill-rule="evenodd" clip-rule="evenodd"
						d="M18.7897 10.4313C19.2123 10.8539 19.2123 11.5392 18.7897 11.9618L13.3326 17.4189C12.91 17.8415 12.2247 17.8415 11.8021 17.4189L9.07357 14.6904C8.65092 14.2677 8.65092 13.5825 9.07357 13.1598C9.49621 12.7372 10.1814 12.7372 10.6041 13.1598L12.5674 15.1231L17.2592 10.4313C17.6818 10.0087 18.3671 10.0087 18.7897 10.4313Z"
						fill="white" />
				</g>
				<defs>
					<clipPath id="clip0_3943_57719">
						<rect width="27" height="27" fill="white" />
					</clipPath>
				</defs>
			</svg>

		</span>
		<span>{{ validator.title }}</span>
	</div>
</div>